export default __webpack_public_path__ + "static/media/ic-ppt.6d3d822d.svg";